module.exports = __webpack_public_path__ + "assets/oracle.c30c9a04.svg";